/* eslint-disable lingui/no-unlocalized-strings -- intentionally not translated */
import { Link } from '@tanstack/react-router';
import { Trans } from '@lingui/react/macro';
import { useCurrentUser } from '../../services/userHooks';
import { handleLogout } from '../../utils/logout';

function MobileNavLinks() {
  const { currentUser } = useCurrentUser();
  return (
    <div className="side-nav-mobile block pb-10 md:hidden">
      <div className="mobile-nav-divider"></div>

      <Link to="/settings/account" className="side-item">
        <Trans>Settings</Trans>
      </Link>
      <button
        onClick={() => {
          if (currentUser?.formKey) {
            handleLogout(currentUser.formKey);
          }
        }}
        className="side-item w-full"
      >
        <Trans>Sign Out</Trans>
      </button>

      <div className="mobile-nav-divider"></div>

      <a href="/faq" className="side-item">
        Help &amp; FAQ
      </a>
      <a href="/apps" className="side-item">
        Apps
      </a>
      <a href="/save" className="side-item">
        How to Save
      </a>
      <a href="/premium" className="side-item">
        Premium
      </a>
      <a
        href="http://blog.instapaper.com"
        target="_blank"
        rel="noreferrer"
        className="side-item"
      >
        Blog <small className="mobile-nav-external-indicator">↗</small>
      </a>
      <a href="/api" className="side-item">
        API
      </a>
      <a href="/press" className="side-item">
        Press
      </a>
      <a href="/publishers" className="side-item">
        Publishers
      </a>
      <a href="/terms" className="side-item">
        Privacy &amp; Terms
      </a>

      <div className="mobile-nav-divider"></div>

      <a
        href="http://twitter.com/instapaper"
        target="_blank"
        rel="noreferrer"
        className="side-item"
      >
        Twitter
      </a>
      <a
        href="https://www.facebook.com/instapaperholdings"
        target="_blank"
        rel="noreferrer"
        className="side-item"
      >
        Facebook
      </a>
    </div>
  );
}

export default MobileNavLinks;
